import styles from 'components/cards/palette/ReportedPostCard.module.scss';


const ReportedPostCard = () => {
    return (
        <div className={styles.root}>
            <span className={styles.mainText}>해당 포스트는 신고 처리된 포스트입니다</span>
            <span className={styles.subtext}>사진 혹은 동영상을 게시한 사람에게<br/> 신고한 사람의 정보는 공개되지 않아요.</span>
        </div>
    )
};

export default ReportedPostCard;
